import { Props_SnippetMotto } from './Motto.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler';
import SharedHeading from "../Shared/Heading/Heading";

export const SnippetMotto = (props: Props_SnippetMotto) => {
    const { motto, content, image } = props;
    
    // Handle backward compatibility for heading text - support both new and old prop names
    const headingText = motto.text?.value || (motto as any).heading?.value;
    
    // Determine visibility state - handle both boolean and string values from CMS
    const isVisible = typeof motto.visibility?.value === 'boolean' ? motto.visibility.value : motto.visibility?.value === 'true';

    return (
        <section className="snippet-motto">
            <img src="/Blob/images/snippets/motto/overlay-top-right.svg" loading="lazy" width="77" height="154" className="snippet-motto__overlay snippet-motto__overlay--top-right" alt=""></img>

            <div className="snippet-motto__container">
                <div className="snippet-motto__container-image">
                    {image?.image?.value && (
                        <img 
                            src={image.image.value}
                            loading="lazy" 
                            width={700}
                            height={420}
                            className="snippet-motto__image" 
                            alt={image.alt?.value || ''}
                        />
                    )}
                </div>
                
                <div className="snippet-motto__container-content">
                    <SharedHeading
                        className="snippet-motto__heading"
                        level={motto.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h2'}
                        alignment={
                            motto.alignment?.value === "start" ||
                            motto.alignment?.value === "center" ||
                            motto.alignment?.value === "end"
                                ? motto.alignment.value
                                : undefined
                        }
                        visibility={isVisible}
                    >
                        {headingText}
                    </SharedHeading>
                    
                    {content.content?.value && (
                        <div className="snippet-motto__content">
                            {CompileMarkdown(content.content.value)}
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
}

export default SnippetMotto
